import React, { useState } from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import {
  myTimesheetMyRequestsDashboardTable,
  myTimesheetMyRequestsDashboardTableIsMobile,
} from "my-timesheet/configs/table-defs";
import { OcDataTable } from "oc/components";
import { useOcTableState } from "oc/hooks";

type MyTimesheetMyRequestsDashboardTableProps = {
  data: Array<{ _id?: string; name?: string; [key: string]: any }>;
  type: any;
  loading: boolean;
  isMobile: boolean;
};

export const MyTimesheetMyRequestsDashboardTable = ({
  data,
  type,
  loading,
  isMobile,
}: MyTimesheetMyRequestsDashboardTableProps) => {
  const [tableData, setTableData] = useOcTableState(
    "myTimesheetMyRequestsDashboardProjectTable",
    {
      page: 1,
      pageSize: 10,
      sortField: "name",
      sortDirection: "asc",
      searchText: "",
    },
  );

  const filteredData = tableData?.searchText
    ? data.filter((item) =>
        item?.name
          ?.toLowerCase()
          ?.includes(tableData?.searchText?.toLowerCase()),
      )
    : data;

  const sortedData = _.orderBy(
    filteredData,
    [tableData?.sortField],
    [
      tableData?.sortDirection === "asc" || tableData?.sortDirection === "desc"
        ? tableData?.sortDirection
        : "asc",
    ],
  );

  const paginatedData = sortedData?.slice(
    (tableData?.page - 1) * tableData?.pageSize,
    tableData?.page * tableData?.pageSize,
  );

  const tableDef = isMobile
    ? myTimesheetMyRequestsDashboardTableIsMobile(type)
    : myTimesheetMyRequestsDashboardTable(type);

  const requestsData = {
    rows: paginatedData,
    total: filteredData?.length,
    page: tableData?.page,
    pageSize: tableData?.pageSize,
    searchText: tableData?.searchText,
  };

  const handleTableDataChange = (updatedData: Partial<typeof tableData>) => {
    const newTableData = { ...tableData, ...updatedData };
    const keys = Object.keys(updatedData).toString();
    setTableData(newTableData);
    if (
      keys === "searchField" ||
      (keys === "searchText" &&
        !!updatedData?.searchText &&
        updatedData.searchText.length < 3)
    ) {
      return;
    }
  };

  const [selectedRowId, setSelectedRowId] = useState<string | undefined>(
    undefined,
  );

  const onSelectRow = (row: {
    _id?: string;
    name?: string;
    [key: string]: any;
  }) => {
    let selectedId =
      selectedRowId === row?._id ? undefined : (row?._id ?? undefined);
    setSelectedRowId(selectedId);
  };

  const filteredTableDef = {
    id: myTimesheetMyRequestsDashboardTable(type)?.id,
    columns: myTimesheetMyRequestsDashboardTable(type)?.columns?.filter(
      (column) =>
        !myTimesheetMyRequestsDashboardTableIsMobile(type)?.columns?.some(
          (mobileColumn) => mobileColumn?.id === column?.id,
        ),
    ),
  };

  return (
    <Box>
      <OcDataTable
        data={requestsData}
        tableDef={tableDef}
        tableData={tableData}
        setTableData={handleTableDataChange}
        pagination={true}
        loading={loading}
        onSelectRow={onSelectRow}
        selectedRowId={selectedRowId}
        filteredTableDef={filteredTableDef}
      />
    </Box>
  );
};

export default MyTimesheetMyRequestsDashboardTable;
